import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { WorkspaceAssignmentsMonitorScreen } from '@/features/assessments/components/workspace/AssignmentsMonitorScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/assessments/assignments/')({
  validateSearch: z.object({
    assessmentId: z.string().optional(),
    status: z.enum(['pending', 'in_progress', 'completed']).optional(),
    clientId: z.string().optional(),
  }),
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: ClinicalAssignmentsMonitorRoute,
  staticData: { crumb: 'Assignments' },
});

function ClinicalAssignmentsMonitorRoute() {
  return <WorkspaceAssignmentsMonitorScreen surface="clinical" />;
}
